var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipmentName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#727A82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.675 1.537c-.666.111-1.298.612-1.512 1.198l-.071.196-2.039.01-2.038.009-.232.114c-.304.15-.569.415-.719.719l-.114.232v11.97l.114.232c.15.304.415.569.719.719l.232.114 2.576.009 2.576.009V15.833H4.33l-.082-.081-.081-.082V4.33l.081-.082.082-.081H6.267v2.166h7.466V4.167H15.67l.082.081.081.082v4.003h1.236l-.01-2.159-.009-2.159-.114-.232a1.623 1.623 0 0 0-.719-.719l-.232-.114-2.031-.017-2.032-.016-.086-.21c-.337-.821-1.259-1.32-2.161-1.17m.642 1.292a.758.758 0 0 1 .348 1.038.754.754 0 0 1-.965.33c-.352-.159-.512-.481-.43-.863a.734.734 0 0 1 .73-.566c.106 0 .239.026.317.061m4.983 9.354c-1.292 1.293-2.365 2.35-2.383 2.35-.018 0-.562-.528-1.209-1.175l-1.175-1.174-.433.433-.433.433 1.625 1.625 1.625 1.625 2.8-2.8 2.799-2.8-.433-.433-.433-.434-2.35 2.35",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentName);
export default __webpack_public_path__ + "static/media/equipment-name.8161ce08e24ea2d1d0f33fd505ae4b41.svg";
export { ForwardRef as ReactComponent };